// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DigitalpaymentTransactionWebhookPayload {
    static getAttributeTypeMap() {
        return DigitalpaymentTransactionWebhookPayload.attributeTypeMap;
    }
}
DigitalpaymentTransactionWebhookPayload.discriminator = undefined;
DigitalpaymentTransactionWebhookPayload.additionalProperties = false;
DigitalpaymentTransactionWebhookPayload.attributeTypeMap = [
    {
        "name": "methodOfPaymentType",
        "baseName": "methodOfPaymentType",
        "type": "string"
    },
    {
        "name": "methodOfPaymentSubType",
        "baseName": "methodOfPaymentSubType",
        "type": "string"
    },
    {
        "name": "status",
        "baseName": "status",
        "type": "string"
    },
    {
        "name": "externalAccount",
        "baseName": "externalAccount",
        "type": "DigitalpaymentExternalAccountDetail"
    },
    {
        "name": "returnDetails",
        "baseName": "returnDetails",
        "type": "DigitalpaymentReturnDetails"
    },
    {
        "name": "rejectDetails",
        "baseName": "rejectDetails",
        "type": "DigitalpaymentRejectDetails"
    },
    {
        "name": "invoicePayableNumbers",
        "baseName": "invoicePayableNumbers",
        "type": "Array<string>"
    },
    {
        "name": "confirmationNumber",
        "baseName": "confirmationNumber",
        "type": "string"
    },
    {
        "name": "endToEndId",
        "baseName": "endToEndId",
        "type": "string"
    },
    {
        "name": "valueDate",
        "baseName": "valueDate",
        "type": "Date"
    },
    {
        "name": "createDateTime",
        "baseName": "createDateTime",
        "type": "Date"
    },
    {
        "name": "effectiveDate",
        "baseName": "effectiveDate",
        "type": "Date"
    },
    {
        "name": "createdBy",
        "baseName": "createdBy",
        "type": "string"
    },
    {
        "name": "creditOrDebit",
        "baseName": "creditOrDebit",
        "type": "string"
    },
    {
        "name": "currency",
        "baseName": "currency",
        "type": "string"
    },
    {
        "name": "paymentAmount",
        "baseName": "paymentAmount",
        "type": "number"
    },
    {
        "name": "counterpartyEntity",
        "baseName": "counterpartyEntity",
        "type": "DigitalpaymentCounterpartyEntityDetail"
    },
    {
        "name": "counterpartyUser",
        "baseName": "counterpartyUser",
        "type": "DigitalpaymentCounterpartyUserDetail"
    },
    {
        "name": "transactionReferences",
        "baseName": "transactionReferences",
        "type": "Array<DigitalpaymentTransactionReference>"
    },
];
//# sourceMappingURL=digitalpaymentTransactionWebhookPayload.js.map